import BaseModelFactory from './base.factory'
import AgentPackageFeatureService from './../services/AgentPackageFeature.service'
import AgentPackageFeature from './../models/agent-package-feature.model'

class AgentPackageFeatureFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: AgentPackageFeatureService, Model: AgentPackageFeature }
    )
  static findById = async id =>
    await this._findBy({ id: id }, { Service: AgentPackageFeatureService, Model: AgentPackageFeature })
  static create = payload =>
    this._create(payload, {
      Service: AgentPackageFeatureService,
      Model: AgentPackageFeature,
    })
}

export default AgentPackageFeatureFactory
